import { Alert } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import s from './Empty.module.scss';

type EmptyProps = {
  className?: string;
  title?: string;
  level: number;
};

const Empty: React.FC<EmptyProps> = ({ className, level, title = 'Данные не найдены' }) => {
  return (
    <div className={cn(s.root, level === 1 && s['root_no-padding'], className)}>
      <Alert p="xxs" title={title} color="blue" />
    </div>
  );
};

export default React.memo(Empty);
